import Joi from 'joi';

const campaignValidator = Joi.object({
  dateTime: Joi.object({
    defaultTimeZone: Joi.string()
      .label('Time Zone')
      .required()
      .messages({
        'string.base': 'Time Zone is required'
      }),
    checkInTime: Joi.string()
      .label('Check In')
      .invalid('Invalid date')
      .required()
      .messages({
        'any.invalid': 'Invaild Check In Time',
        'string.base': 'Check In Time is required'
      }),
    checkOutTime: Joi.string()
      .label('Check Out')
      .invalid('Invalid date')
      .required()
      .messages({
        'any.invalid': 'Invaild Check Out Time',
        'string.base': 'Check Out Time is required'
      })
  })
});

export default campaignValidator;
